import React, { FC, useEffect, useState } from 'react';
import {
  Edit,
  EditProps,
  FormTab,
  TabbedForm,
  useEditController,
  useRedirect,
} from 'react-admin';
import { User } from '../../types/user';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import UserGeneralTab from './GeneralTab';
import SecurityTab from './SecurityTab';
import TicketsTab from './TicketsTab';
import UserToolbar from './UserToolbar';
import './index.css';
import ReplyIcon from '@material-ui/icons/Reply';
import { Box } from '@material-ui/core';
import CreditTab from './CreditTab';
import ReferralTab from './ReferralTab';
import { CouponTab } from './CouponTab';
import { PaymentsTab } from './PaymentsTab';
import { SubscriptionsTab } from './SubscriptionsTab';
import { parsePhone } from '../../helpers/parsePhone';

const EditUser: FC<EditProps> = (props) => {
  const controllerProps = useEditController<User>(props);
  const id = props.id ? props.id : controllerProps.record?._id;
  const redirect = useRedirect();
  useEffect(() => {
    if (controllerProps.record) {
      setState({ ...state, isBlocked: controllerProps.record?.isBlocked });
    }
  }, []);
  const [state, setState] = useState({
    isBlocked: false,
  });

  const changeStatus = () => {
    setState({ ...state, isBlocked: !state.isBlocked });
  };
  const toList = () => {
    redirect('/users');
  };

  const userCreatValidation = (values) => {
    const errors: any = {};
    const trimedName = values.name && values.name.trim();
    const trimedSurName = values.surname && values.surname.trim();
    const trimedEmail = values.email && values.email.trim();
    const phoneVal = parsePhone(values.phone);
    console.log('phoneVal: ', phoneVal);
    if (!values.name) {
      errors.name = ['required'];
    } else if (trimedName.length <= 1) {
      errors.name = ['It should be more than 1 character'];
    } else if (!trimedName.match(/^[^!@#$^%&*()"':;<>?/,|0-9]*$/)) {
      errors.name = ['invalid characters'];
    }

    if (!values.surname) {
      errors.surname = ['required'];
    } else if (trimedSurName.length <= 1) {
      errors.surname = ['It should be more than 1 character'];
    } else if (!trimedSurName.match(/^[^!@#$^%&*()"':;<>?/,|0-9]*$/)) {
      errors.surname = ['invalid characters'];
    }

    if (!values.email) {
      errors.email = ['required'];
    } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w{2,10}$/.test(trimedEmail)) {
      errors.email = ['Invalid email'];
    }
    if (!values.phone) {
      // errors.phone = ['required'];
    } else if (
      !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(phoneVal)
    ) {
      errors.phone = ['must be only the numbers'];
    }

    return errors;
  };

  return (
    <div>
      <DocumentTitle
        core='User'
        secondary='Users'
        purpose={`${controllerProps.record?.name}`}
        appointment={`${controllerProps.record?.surname}`}
      />
      <Box display='flex' justifyContent='flex-end'>
        <div className='icon-back'>
          <ReplyIcon onClick={toList} />
        </div>
      </Box>
      <Edit {...props} hasShow={false} hasList={true} className='user-toolbar'>
        <TabbedForm
          validate={userCreatValidation}
          className='user-tabs'
          toolbar={UserToolbar(props, false, state.isBlocked)}
        >
          <FormTab label='General'>
            <UserGeneralTab
              isBlocked={state.isBlocked}
              changeStatus={changeStatus}
              isShow={false}
            />
          </FormTab>
          <FormTab label='Security & Notifications'>
            <SecurityTab
              id={id || ''}
              notifications={controllerProps.record?.notifications}
              user={controllerProps.record}
              isShow={false}
            />
          </FormTab>
          <FormTab label='Tickets'>
            <TicketsTab id={id || ''} isShow={false} props={props} />
          </FormTab>
          <FormTab label='Credit'>
            <CreditTab id={id || ''} isShow={false} />
          </FormTab>
          <FormTab label='Referral'>
            <ReferralTab id={id || ''} isView={false} />
          </FormTab>
          <FormTab label='Coupon'>
            <CouponTab id={id || ''} isView={false} />
          </FormTab>
          <FormTab label='Subscriptions'>
            <SubscriptionsTab id={id || ''} />
          </FormTab>
          <FormTab label='Payments'>
            <PaymentsTab id={id || ''} />
          </FormTab>
        </TabbedForm>
      </Edit>
    </div>
  );
};

export default EditUser;
